import {translations} from 'presentation/translations-new';

const {registered, cancelled, denied, analysis, approved, concluded} =
	translations['pt-br'].privateFlow.consultRefund.status;

export const REFUND_PROTOCOL_STATUS = {
	1: registered, // PEDIDO INCLUSO
	4: cancelled, // CANCELADO
	5: denied, // INDEFERIDO
	6: analysis, // ANALISE
	7: approved, // LIBERADO
	8: concluded, // PROTOCOLO CONCLUIDO
};

export type RefundStatusEnum = keyof typeof REFUND_PROTOCOL_STATUS;

type ConsultStatusData = {
	situationCode: RefundStatusEnum;
	situation: string;
	situationAt: string;
};

export type ConsultRefundProtocolStatusData = {
	situationHistories: ConsultStatusData[];
};

export type GetRefundProtocolStatusParams = {protocolCode: string; signal?: AbortSignal};
export type GetRefundProtocolStatusResponse = Promise<ConsultRefundProtocolStatusData>;

export interface GetRefundProtocolStatus {
	get: (params: GetRefundProtocolStatusParams) => Promise<GetRefundProtocolStatusResponse>;
}
